import axios from 'axios'
import apiUrl from '../_const'

export default {
  getFloating () {
    return axios.get(apiUrl.FLOATING_URL, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  assignFloatingToServer ({ commit }, data) {
    return axios.post(apiUrl.FLOATING_URL + '/assign', {
      floating_id: data.FloatingId,
      compute_id: data.ComputeId
    }, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  requestNewFloating () {
    return axios.post(apiUrl.FLOATING_URL, {}, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  deleteFloating ({ commit }, id) {
    return axios.post(apiUrl.FLOATING_URL + '/delete', {
      id: id
    }, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/openstack/modules/floating.js